// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2n7hd","box":"WorkspacesBox_box__3bLHz","node":"WorkspacesBox_node__Iagfz"};